<template>
  <UrgencyCheckbox
    v-if="urgencies.length == 1 && !isAppointment"
    :model-value="urgency != 'none'"
    :urgency="urgencies[0]"
    @update:model-value="setUrgency($event)"
  />
  <UrgencySelect v-else v-model="urgency" :urgencies :is-appointment />
</template>

<script setup lang="ts">
import type { Urgency, VisaForm } from '~/types';

const urgency = defineModel<VisaForm['urgency']>({ required: true });
const props = defineProps<{
  urgencies: Urgency[];
}>();

const isAppointment = props.urgencies.some(u => u.isAppointment);

function setUrgency(value: boolean) {
  urgency.value = value ? props.urgencies[0].speed : 'none';
}
</script>